import Navigation from "@/components/wedding/Navigation";
import Hero from "@/components/wedding/Hero";
import CommandCenter from "@/components/wedding/CommandCenter";
import OurStory from "@/components/wedding/OurStory";
import Schedule from "@/components/wedding/Schedule";
import DressCode from "@/components/wedding/DressCode";
import TravelAccommodation from "@/components/wedding/TravelAccommodation";
import RSVPCallout from "@/components/wedding/RSVPCallout";
import Footer from "@/components/wedding/Footer";

export default function WeddingHome() {
  return (
    <div className="min-h-screen bg-[#FAF9F6] text-[#1A1818]">
      <Navigation />
      <main>
        <Hero />
        <CommandCenter />
        <OurStory />
        <Schedule />
        <DressCode />
        <TravelAccommodation />
        <RSVPCallout />
      </main>
      <Footer />
    </div>
  );
}
